import { forwardRef } from "react";
import { GetPostQuery } from "@/__generated__/graphql";
import className from "classnames/bind";
import { motion } from "motion/react";

import styles from "./CantUnhearItBullets.module.scss";

type TracksType =
  GetPostQuery["rhPost"]["featureData"]["sonicConnections"]["tracks"];

type CantUnhearItBulletsProps = {
  tracks: TracksType;
  currentTrackIndex?: number;
  goToTrack?: (index: number) => void;
};

const cx = className.bind(styles);

const CantUnhearItBullets = forwardRef<
  HTMLUListElement,
  CantUnhearItBulletsProps
>(({ tracks, goToTrack, currentTrackIndex = -1 }, ref) => {
  return (
    <ul className={cx("cant-unhear-it__bullets")} ref={ref}>
      {tracks?.map((track, index) => (
        <li
          key={index}
          className={cx("cant-unhear-it__bullet", {
            active: currentTrackIndex === index,
          })}
          onClick={() => goToTrack(index)}
        ></li>
      ))}
    </ul>
  );
});

export default motion.create(CantUnhearItBullets);
